/* eslint-disable no-unused-expressions */
/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-undef */
export default (
  department = { success: null, error: null, depart: [] },
  action
) => {
  switch (action.type) {
    case "GET_ALL_DEPARTMENTS":
      return { ...department, depart: action.payload };
    case "CREATE_DEPARTMENT":
      return { ...department, depart: [...department.depart, action.payload] };
    case "DELETE_DEPARTMENT":
      return {
        ...department,
        depart: department.depart.filter((data) => data._id !== action.payload),
      };
    case "UPDATE_DEPARTMENT":
      return { ...department, depart: [...department.depart, action.payload] };
    default:
      return department;
  }
};
